export const csvToJson = (csv) => {
  var lines = csv.split('\n');
  return lines.map((line) => line.replace(';', ' ').replace(/"/g, '').trim());
};

export const csvToCodeLabelOptions = (csv) => {
  if (!csv) {
    return [];
  }

  return csv
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line !== '')
    .map((line) => {
      const parts = line
        .split(';')
        .map((part) => part.replace(/"/g, '').trim())
        .filter((part) => part !== '');

      if (parts.length === 0) {
        return null;
      }

      if (parts.length === 1) {
        return { code: parts[0], label: parts[0] };
      }

      // Title rows are expected as "label;code".
      const label = parts[0];
      const code = parts[1];
      return { code, label: label || code };
    })
    .filter((option) => option !== null);
};

export const csvToCostCentreCodeLabelOptions = (csv) => {
  if (!csv) {
    return [];
  }

  return csv
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line !== '')
    .map((line) => {
      const parts = line
        .split(';')
        .map((part) => part.replace(/"/g, '').trim())
        .filter((part) => part !== '');

      if (parts.length === 0) {
        return null;
      }

      if (parts.length === 1) {
        return { code: parts[0], label: parts[0] };
      }

      // Title rows are expected as "label;code".
      const label = parts[1];
      const code = parts[0];
      return { code, label: label || code };
    })
    .filter((option) => option !== null);
};
